import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

interface ITextContentProps extends WithTranslation {
    title: string;
    description: string;
    descriptionCTAComponent?: React.ReactNode;
    subtitleCTAComponent?: React.ReactNode;
}

const TextContent = (props: ITextContentProps) => {
    const { t } = props;

    return (
        <div className="text-content-container">
            <h2 className="header-1 text-content-title">{t(props.title)}</h2>
            <div className="text-content-subtitle">{props.subtitleCTAComponent}</div>
            <div className="body-large">
                {t(props.description)}
                {props.descriptionCTAComponent}
            </div>
        </div>
    );
};

export default withTranslation()(TextContent);
